<div class="row justify-content-center">
  <div class="col-lg-6">
    <div class="block border my-2">
      <div class="border-bottom p-2">
        <h4>Overview</h4><br/>
        Count of errors: 0<br/>
        Count of projects: 0<br/>
        Count of alarms: 0<br/>
        Last alarm happened at: 2024-01-01 00:00:00.0 details<br/>
      </div>
    </div>
  </div>
</div>
